<div class="measurement-view-container">
    <div class="measurement-content" *ngIf="!loading; else spinner">
        <div class="measurement-body">
            <div class="empty-state" *ngIf="!selectedMeasurementId && !measurementData">
                <p class="empty-text">No measurement selected</p>
            </div>

            <div class="measurement-details" *ngIf="measurementData">
                <app-tabset #tabset>
                    <app-tab title="Details">
                        <ng-template appTabContent>
                            <!-- Control Panel -->
                            <app-control-panel (settingsChanged)="onSettingsChanged($event)"></app-control-panel>

                            <!-- Trend Graph -->
                            <app-trend-graph [settings]="controlSettings"></app-trend-graph>

                            <!-- Response Graph -->
                            <app-response-graph></app-response-graph>

                            <!-- Data Table -->
                            <app-data-table [timeFormat]="controlSettings.timeFormat"></app-data-table>
                        </ng-template>
                    </app-tab>
                    <app-tab title="Report">
                        <ng-template appTabContent>
                            <app-report-actions
                                [controlSettings]="controlSettings"
                                [measurementData]="measurementData"
                                [selectedMeasurementId]="selectedMeasurementId"
                            ></app-report-actions>
                        </ng-template>
                    </app-tab>
                </app-tabset>

                <div [appTabsetOutlet]="tabset"></div>
            </div>
        </div>
    </div>
</div>

<ng-template #spinner>
    <app-spinner />
</ng-template>
